import { Info, ShieldCheck, FileText, Mail } from "lucide-react";
import { Seo } from "../components/Seo";

const About = () => (
  <div className="paper-texture">
    <Seo title="Hakkımızda & Yasal Uyarı | SPK Aracı Kurumlar"
      description="spkaracikurumlar.com bağımsız bir aracı kurum rehberidir. İletişim bilgileri kamuya açık kaynaklardan derlenmiştir; yatırım tavsiyesi değildir."
      path="/hakkimizda" />
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-14">
      <span className="kicker text-claret">Kurumsal</span>
      <h1 className="mt-2 border-b-2 border-ink pb-5 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">Hakkımızda & Yasal Uyarı</h1>

      <p className="drop-cap mt-7 font-display text-lg leading-[1.85] text-ink/90">
        spkaracikurumlar.com, Türkiye'de Sermaye Piyasası Kurulu (SPK) tarafından yetkilendirilmiş aracı
        kurumların iletişim bilgilerini, güncel borsa haberlerini ve kurum karşılaştırmalarını tek bir çatı
        altında sunan bağımsız bir rehber portalıdır. Amacımız yatırımcıların doğru kuruma hızlı ve kolay
        şekilde ulaşmasını sağlamaktır.
      </p>

      <div className="mt-8 border-l-2 border-claret bg-tint/60 p-6" data-testid="about-disclaimer">
        <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-ink"><Info size={18} className="text-claret" /> Önemli Bilgilendirme</h2>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          Sitemizde yer alan aracı kurumların iletişim numaraları ve kurumsal bilgileri, Kamuyu Aydınlatma
          Platformu (KAP), SPK duyuruları ve kamuya açık kaynaklarda <strong className="text-ink">bildirilen haberlerden alınmıştır.</strong>{" "}
          Bilgiler zamanla değişebilir; herhangi bir işlem yapmadan önce ilgili kurumun resmi kanallarından teyit edilmesi önerilir.
        </p>
      </div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2">
        <div className="border border-hair bg-card p-6">
          <ShieldCheck size={22} className="text-claret" />
          <h3 className="mt-3 font-display text-lg font-semibold text-ink">Yatırım Tavsiyesi Değildir</h3>
          <p className="mt-2 text-sm text-muted-foreground">Sitedeki içerikler ve haberler yalnızca bilgilendirme amaçlıdır; alım-satım ya da yatırım tavsiyesi niteliği taşımaz.</p>
        </div>
        <div className="border border-hair bg-card p-6">
          <FileText size={22} className="text-claret" />
          <h3 className="mt-3 font-display text-lg font-semibold text-ink">Otomatik Haber Sistemi</h3>
          <p className="mt-2 text-sm text-muted-foreground">Borsa haberleri her gün otomatik olarak güvenilir kaynaklardan çekilip yapay zeka ile özetlenerek güncel tutulur.</p>
        </div>
      </div>

      <div className="mt-8 flex items-center gap-3 border border-hair bg-card p-6" data-testid="about-contact">
        <Mail size={20} className="text-claret" />
        <div>
          <div className="kicker text-muted-foreground">İletişim</div>
          <a href="mailto:info@spkaracikurumlar.com" className="text-sm font-medium text-ink hover:text-claret">info@spkaracikurumlar.com</a>
        </div>
      </div>
    </div>
  </div>
);

export default About;
